/**
 * Redirection when the user session has expired.
 *
 * EduBook (edubook-def) may store in localStorage the URL where some users
 * (e.g. Mladinska users) must land when their session ends, instead of the
 * EduBook login. If it is missing or not valid, the default flow is kept.
 */

export const SESSION_END_REDIRECT_URL_STORAGE_KEY = 'onLogoutRedirectUrl'

const ALLOWED_PROTOCOLS = ['http:', 'https:']

export const getSessionEndRedirectUrl = () => {
  try {
    const value = localStorage.getItem(SESSION_END_REDIRECT_URL_STORAGE_KEY)?.trim()
    if (!value) return null

    const url = new URL(value)
    return ALLOWED_PROTOCOLS.includes(url.protocol) ? url.href : null
  } catch (error) {
    // Storage unavailable (private mode) or malformed URL
    return null
  }
}

export const getEdubookLoginUrl = () => {
  const referral = encodeURIComponent(window.location.href)
  return `${window.viewer.edubookLogin}?rf=${referral}`
}

export const getSessionExpiredRedirectUrl = () => getSessionEndRedirectUrl() ?? getEdubookLoginUrl()
